import { FunctionComponent, useMemo, type JSX } from 'react';

import { usePermissions } from '@/hooks/usePermissions';
import { Text } from '@payaca/ambrosia';
import { AnnouncementBanner } from '@payaca/components/announcementBanner/AnnouncementBanner';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import { Link } from 'react-router-dom';
import { PermissionGuard } from '../permissionGuard/PermissionGuard';
import './UserSeatsExceededBanner.css';

const UserSeatsExceededBanner: FunctionComponent = (): JSX.Element | null => {
  const { userHasRequiredPermission } = usePermissions();
  const currentUserIsAdmin = useMemo(() => {
    return userHasRequiredPermission([AccountsPermissions.UPDATE_SUBSCRIPTION]);
  }, [userHasRequiredPermission]);

  const isOnManageSubscriptionPage = useMemo(() => {
    return location.pathname == '/upgradeAccount';
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has an unnecessary dependency: location.
  }, [location]);

  return (
    <AnnouncementBanner>
      <div className="flex flex-row items-baseline gap-4">
        <div className="mr-auto">
          <Text>
            The number of users exceeds the user capacity of this account.{' '}
            {!currentUserIsAdmin &&
              'Please contact your account administrator.'}
          </Text>
        </div>
        {!isOnManageSubscriptionPage && (
          <PermissionGuard
            renderIfHasPermissions={[AccountsPermissions.UPDATE_SUBSCRIPTION]}
          >
            <Link to="/upgradeAccount">
              <AnnouncementBanner.Button>
                Add more users
              </AnnouncementBanner.Button>
            </Link>
          </PermissionGuard>
        )}
      </div>
    </AnnouncementBanner>
  );
};

export default UserSeatsExceededBanner;
